package com.havn.app.core.presentation

fun Throwable.havnFriendlyMessage(fallback: String = "Something went wrong. Please try again."): String =
    message.havnFriendlyMessage(fallback)

fun String?.havnFriendlyMessage(fallback: String = "Something went wrong. Please try again."): String {
    val raw = this?.trim().orEmpty()
    if (raw.isBlank()) return fallback

    val normalized = raw.lowercase()
    return when {
        normalized.contains("cancel") -> "Cancelled."
        normalized.contains("network") ||
            normalized.contains("socket") ||
            normalized.contains("host") ||
            normalized.contains("connection") ||
            normalized.contains("timed out") ->
            "The connection is taking too long. Please try again."
        normalized.contains("statement timeout") ||
            normalized.contains("canceling statement") ->
            "This is taking longer than expected. Please try again."
        normalized.contains("row-level security") ||
            normalized.contains("permission denied") ||
            normalized.contains("not authorized") ||
            normalized.contains("unauthorized") ||
            normalized.contains("forbidden") ->
            "You do not have permission to do that."
        normalized.contains("duplicate key") ||
            normalized.contains("already exists") ->
            "This item already exists."
        normalized.contains("violates foreign key") ||
            normalized.contains("foreign key constraint") ->
            "This item is linked to other data and cannot be changed this way."
        normalized.contains("violates not-null") ||
            normalized.contains("null value") ->
            "Some required information is missing."
        normalized.contains("invalid input") ||
            normalized.contains("invalid uuid") ||
            normalized.contains("invalid token") ->
            "Some information does not look right. Please check it and try again."
        normalized.contains("file too large") ||
            normalized.contains("payload too large") ||
            normalized.contains("413") ->
            "This file is too large. Please choose a smaller one."
        raw.looksTechnical() -> fallback
        else -> raw
    }
}

private fun String.looksTechnical(): Boolean {
    val normalized = lowercase()
    return listOf(
        "code:",
        "hint:",
        "details:",
        "url:",
        "headers:",
        "http method:",
        "/rest/v1/",
        "/rpc/",
        "postgrest",
        "supabase",
        "ktor",
        "json",
        "sql",
        "psql",
        "relation \"",
        "column \"",
        "function ",
        "does not exist",
        "violates",
        "constraint",
        "exception",
        "nsurlerrordomain",
        "asauthorization",
        "authorizationerror",
        "domain=",
        "stacktrace"
    ).any(normalized::contains)
}
